import { useQuery } from '@tanstack/react-query';
import { env } from '@/config/env';
import { api } from '@/lib/api';

/** A staging QA/demo account for the sign-in role cards (no secrets). */
export interface DemoAccount {
  role: string;
  roleName: string;
  email: string;
  name: string;
}

/**
 * GET /demo/accounts (RL-1017). The API answers only outside production and
 * only after `db:seed:demo`; anything else (404, network) means no cards.
 */
export function useDemoAccounts() {
  return useQuery({
    queryKey: ['demo-accounts'],
    queryFn: ({ signal }) =>
      api
        .get<DemoAccount[]>('/demo/accounts', { signal })
        .then((r) => r.data)
        .catch(() => [] as DemoAccount[]),
    enabled: env.appEnv !== 'production',
    staleTime: Infinity,
    retry: false,
  });
}
